<style type="text/css">
  .container-feedback {
    max-width: 600px;
  }
</style>

<template>
  <v-container class="container-feedback">
    <v-row>
      <v-col>
        <div style="text-align: center; padding-bottom: 30px; font-size: 16px; max-width: 500px; margin: 0 auto;" v-html="translate('ui_feedback_prompt')">
        </div>
        <v-textarea
          v-model="message"
          auto-grow
          outlined
          background-color="amber lighten-5"
          ref="message"
          :placeholder="translate('ui_feedback_message')"
        ></v-textarea>

        <v-text-field
          :label="translate('ui_feedback_email')"
          ref="emailInput"
          type="email"
          clearable
        ></v-text-field>

        <div
          style="margin-top: 30px; text-align: center;"
        >
          <v-btn large @click="shareFeedback"><v-icon>mdi-message-outline</v-icon>
            <span style="padding-left: 10px;">
              {{ translate('ui_feedback_send')}}
            </span>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="snackbarMessageSent"
      :timeout="4000"
      color="success"
      top
      centered
    >
      Message sent. Thank you!
    </v-snackbar>

  </v-container>
</template>

<script>
// mixins
import Mixin from '../mixins/mixin';

export default {
  mixins: [Mixin],
  data: () => ({
    snackbarMessageSent: false,
  }),
  methods: {
    shareFeedback() {
      const message = this.$refs.message.$refs.input.value;
      const email = this.$refs.emailInput.$refs.input.value;
      this.$store.dispatch('shareFeedback', { message, email });
      setTimeout(() => {
        this.snackbarMessageSent = true;
      }, 1000);
    },
  },
  computed: {
    message: {
      get() {
        return '';
      },
      set(newValue) {
        return newValue;
      },
    },
  },
  mounted() {
    // this.$store.commit('updatePageTitle', 'ui_left_menu__feedback');
    this.$refs.message.$refs.input.focus();
  },
};

</script>
